export default __webpack_public_path__ + "static/media/percona.6ac49912.svg";